/* ==========================================================================
   ASURA — Agregar al carrito: llenado de oro (A) + hoja de confirmación (C)

   Se engancha a los eventos que ya dispara el tema, sin tocar theme.js:
     submit del formulario de producto   → empieza el llenado (la espera de la
                                           tienda se vuelve parte de la animación)
     ajaxProduct:added (con el producto)  → completa el oro, "En tu carrito",
                                           toque leve en Android y sube la hoja
     ajaxProduct:error                    → el oro se vacía y el tema muestra
                                           su mensaje de error
   Al cerrar la hoja, el carrito dorado de la píldora aparece o rebota y el
   botón vuelve a "Agregar al carrito".
   Con el carrito tipo "Cajón", el tema abriría su carrito lateral al agregar:
   en la ficha lo calla la hoja (se abre después con "Ver carrito").
   Marcado: snippets/asura-carrito.liquid · Estilos: assets/asura-carrito.css
   ========================================================================== */
(function () {
  'use strict';

  if (window.asuraCarrito) return;
  window.asuraCarrito = true;

  var reducido = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  function dur(ms) { return reducido.matches ? 1 : ms; }

  function animar(el, cuadros, opciones) {
    if (!el || !el.animate) return { finished: Promise.resolve(), cancel: function () {} };
    var a = el.animate(cuadros, opciones);
    if (!a.finished) {
      a.finished = new Promise(function (r) { a.onfinish = r; });
    }
    return a;
  }

  function cancelar(el) {
    if (el && el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); });
  }

  function vibrar() {
    try { if (navigator.vibrate) navigator.vibrate(14); } catch (e) {}
  }

  function dinero(centavos) {
    try {
      return theme.Currency.formatMoney(centavos, theme.settings.moneyFormat);
    } catch (e) {
      return '$' + (centavos / 100).toFixed(2);
    }
  }

  function oracion(texto) {
    texto = String(texto || '').trim().toLowerCase();
    return texto ? texto.charAt(0).toUpperCase() + texto.slice(1) : '';
  }

  /* ------------------------------------------------------------------------
     A. Llenado de oro
     ------------------------------------------------------------------------ */
  var PALOMITA = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function preparar(boton) {
    var s = boton._asura;
    if (s && boton.contains(s.capa)) return s;

    var capa = document.createElement('i');
    capa.className = 'asura-llenado';
    capa.setAttribute('aria-hidden', 'true');
    capa.innerHTML =
      '<i class="asura-llenado__capa">' +
        '<i class="asura-llenado__agregar"></i>' +
        '<i class="asura-llenado__hecho">' + PALOMITA + 'En tu carrito</i>' +
      '</i>' +
      '<i class="asura-llenado__borde"></i>' +
      '<i class="asura-llenado__brillo"></i>';
    boton.appendChild(capa);
    boton.classList.add('asura-boton');

    s = boton._asura = {
      boton: boton,
      capa: capa,
      agregar: capa.querySelector('.asura-llenado__agregar'),
      hecho: capa.querySelector('.asura-llenado__hecho'),
      palomita: capa.querySelector('path'),
      borde: capa.querySelector('.asura-llenado__borde'),
      brillo: capa.querySelector('.asura-llenado__brillo'),
      estado: 'listo',
      corrida: 0,
      subida: null,
      seguro: null
    };
    return s;
  }

  function limpiar(s) {
    [s.capa, s.agregar, s.hecho, s.palomita, s.brillo, s.boton].forEach(cancelar);
    s.capa.style.width = '0px';
    s.capa.style.opacity = '';
    s.borde.style.opacity = '';
    s.brillo.style.opacity = '';
  }

  function iniciar(boton) {
    var s = preparar(boton);
    if (s.estado !== 'listo') return;

    s.corrida++;
    s.estado = 'llenando';
    limpiar(s);

    var w = boton.offsetWidth;
    var texto = boton.querySelector('[data-add-to-cart-text]');
    s.agregar.textContent = (texto ? texto.textContent : boton.textContent).trim();
    s.capa.style.setProperty('--asura-ancho', w + 'px');
    boton.classList.add('asura-llenando');

    // sube rápido a dos tercios y luego avanza despacio mientras la tienda responde
    s.subida = animar(s.capa, [
      { width: '0px', easing: 'cubic-bezier(.25,.8,.35,1)' },
      { width: (w * 0.64) + 'px', offset: 0.2, easing: 'cubic-bezier(.2,.6,.3,1)' },
      { width: (w * 0.9) + 'px' }
    ], { duration: dur(2800), fill: 'forwards' });

    clearTimeout(s.seguro);
    s.seguro = setTimeout(function () {
      if (s.estado === 'llenando') vaciar(s, true);
    }, 15000);
  }

  function completar(s) {
    if (!s || s.estado !== 'llenando') return Promise.resolve(false);
    clearTimeout(s.seguro);
    s.estado = 'lleno';

    var mi = s.corrida;
    var w = s.boton.offsetWidth;
    var actual = parseFloat(getComputedStyle(s.capa).width) || 0;
    if (s.subida) s.subida.cancel();
    s.capa.style.setProperty('--asura-ancho', w + 'px');
    s.capa.style.width = actual + 'px';

    var cierre = animar(s.capa, [{ width: actual + 'px' }, { width: w + 'px' }], {
      duration: dur(220),
      easing: 'cubic-bezier(.3,.7,.4,1)',
      fill: 'forwards'
    });

    return cierre.finished.then(function () {
      if (mi !== s.corrida) return false;
      s.capa.style.width = '100%';
      cierre.cancel();
      s.borde.style.opacity = '0';

      if (!reducido.matches) {
        s.brillo.style.opacity = '1';
        animar(s.brillo, [
          { transform: 'translateX(0) skewX(-20deg)' },
          { transform: 'translateX(' + (w * 1.7) + 'px) skewX(-20deg)' }
        ], { duration: 650, easing: 'cubic-bezier(.45,0,.25,1)', fill: 'forwards' });
        animar(s.boton, [
          { transform: 'scale(1)' },
          { transform: 'scale(1.025)' },
          { transform: 'scale(1)' }
        ], { duration: 280, easing: 'ease-out' });
      }

      animar(s.agregar, [
        { opacity: 1, transform: 'translateY(0)' },
        { opacity: 0, transform: 'translateY(-8px)' }
      ], { duration: dur(170), fill: 'forwards' });
      animar(s.hecho, [
        { opacity: 0, transform: 'translateY(8px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: dur(240), delay: dur(140), easing: 'ease-out', fill: 'both' });
      animar(s.palomita, [
        { strokeDashoffset: '22' },
        { strokeDashoffset: '0' }
      ], { duration: dur(340), delay: dur(200), easing: 'ease-out', fill: 'both' });

      vibrar();
      return true;
    });
  }

  function vaciar(s, rapido) {
    if (!s) return Promise.resolve();
    clearTimeout(s.seguro);
    var mi = ++s.corrida;
    return animar(s.capa, [{ opacity: 1 }, { opacity: 0 }], {
      duration: dur(rapido ? 180 : 320),
      easing: 'ease-in',
      fill: 'forwards'
    }).finished.then(function () {
      if (mi !== s.corrida) return;
      limpiar(s);
      s.boton.classList.remove('asura-llenando');
      s.estado = 'listo';
    });
  }

  /* ------------------------------------------------------------------------
     Carrito dorado de la píldora
     En el modo de carrito "fijo" el tema no actualiza el contador ni la clase
     cart-has-items al agregar; aquí se hace con /cart.js.
     ------------------------------------------------------------------------ */
  var carritoNuevo = false;

  function contarCarrito() {
    var url = (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
          b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        });
        return cart.item_count;
      })
      .catch(function () { return 1; });
  }

  function lucirCarrito(nuevo) {
    document.body.classList.add('cart-has-items');
    var seg = document.querySelector('.site-nav__thumb-menu .site-nav__thumb-cart');
    if (!seg || reducido.matches) return;

    function rebotar() {
      seg.classList.remove('asura-entra', 'asura-rebota', 'asura-burbuja');
      void seg.offsetWidth;
      seg.classList.add('asura-rebota', 'asura-burbuja');
      vibrar();
      setTimeout(function () { seg.classList.remove('asura-rebota', 'asura-burbuja'); }, 800);
    }

    if (nuevo) {
      seg.classList.remove('asura-entra', 'asura-rebota', 'asura-burbuja');
      void seg.offsetWidth;
      seg.classList.add('asura-entra');
      setTimeout(rebotar, 420);
    } else {
      rebotar();
    }
  }

  /* ------------------------------------------------------------------------
     C. Hoja de confirmación
     ------------------------------------------------------------------------ */
  var hoja = document.getElementById('AsuraHoja');
  var velo = document.getElementById('AsuraVelo');
  var ultimoBoton = null;

  function abierta() {
    return !!(hoja && hoja.classList.contains('is-abierta'));
  }

  function campo(nombre) {
    return hoja.querySelector('[data-asura-' + nombre + ']');
  }

  function presentacion() {
    var etiqueta = document.querySelector('.asura-presentacion .asura-etiqueta');
    return etiqueta ? oracion(etiqueta.textContent) : '';
  }

  function llenarHoja(p) {
    var foto = campo('foto');
    if (p.image) {
      foto.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=200';
      foto.hidden = false;
    } else {
      foto.hidden = true;
    }
    foto.alt = p.product_title || '';

    campo('casa').textContent = p.vendor || '';
    campo('nombre').textContent = p.product_title || p.title || '';

    var variante = p.variant_title && p.variant_title !== 'Default Title' ? oracion(p.variant_title) : '';
    campo('pres').textContent = [presentacion(), variante].filter(Boolean).join(' · ');

    var precio = p.final_line_price != null ? p.final_line_price : (p.final_price || p.price || 0);
    campo('precio').textContent = (p.quantity > 1 ? p.quantity + ' × ' : '') + dinero(precio);
  }

  function abrirHoja(p) {
    if (!hoja || !velo) {
      lucirCarrito(carritoNuevo);
      carritoNuevo = false;
      if (ultimoBoton) setTimeout(function () { vaciar(ultimoBoton._asura); }, 1600);
      return;
    }
    llenarHoja(p);
    hoja.style.transform = '';
    velo.style.opacity = '';
    hoja.setAttribute('aria-hidden', 'false');
    velo.classList.add('is-abierto');
    hoja.classList.add('is-abierta');

    if (!reducido.matches) {
      hoja.querySelectorAll('[data-asura-escalonar]').forEach(function (el, i) {
        animar(el, [
          { opacity: 0, transform: 'translateY(12px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 360, delay: 140 + i * 70, easing: 'cubic-bezier(.2,.8,.3,1)', fill: 'backwards' });
      });
    }

    setTimeout(function () {
      try { hoja.focus({ preventScroll: true }); } catch (e) { hoja.focus(); }
    }, 60);
  }

  function cerrarHoja() {
    if (!abierta()) return;
    hoja.style.transition = '';
    hoja.style.transform = '';
    velo.style.opacity = '';
    hoja.classList.remove('is-abierta');
    velo.classList.remove('is-abierto');
    hoja.setAttribute('aria-hidden', 'true');

    if (ultimoBoton) {
      try { ultimoBoton.focus({ preventScroll: true }); } catch (e) {}
    }

    setTimeout(function () {
      lucirCarrito(carritoNuevo);
      carritoNuevo = false;
      if (ultimoBoton) vaciar(ultimoBoton._asura);
    }, dur(300));
  }

  /* ------------------------------------------------------------------------
     Carrito lateral del tema (tipo "Cajón")
     Al agregar, el tema abre su carrito lateral; en la ficha manda la hoja.
     Se escucha antes que nadie (captura en window) para callar ese único
     "abrir" y para saber si el carrito ya tenía perfumes antes de agregar.
     Abrir con el carrito dorado, el ícono o "Ver carrito" sigue igual.
     ------------------------------------------------------------------------ */
  var cajonCallado = false;
  var habiaAntes = null;

  if (hoja && window.theme && theme.CartDrawer && theme.CartDrawer.prototype) {
    var abrirCajon = theme.CartDrawer.prototype.open;
    theme.CartDrawer.prototype.open = function () {
      if (cajonCallado) return;
      return abrirCajon.apply(this, arguments);
    };
  }

  window.addEventListener('ajaxProduct:added', function (e) {
    if (!hoja || !e.detail || !e.detail.product) return;
    habiaAntes = document.body.classList.contains('cart-has-items');
    cajonCallado = true;
    setTimeout(function () { cajonCallado = false; }, 0);
  }, true);

  function abrirCarrito() {
    var cajon = document.getElementById('CartDrawer');
    if (cajon && window.theme && theme.settings && theme.settings.cartType === 'drawer') {
      document.dispatchEvent(new CustomEvent('cart:open'));
    } else {
      window.location.href = (window.theme && theme.routes && theme.routes.cartPage) || '/cart';
    }
  }

  if (hoja && velo) {
    // fuera del contenido del tema para que position: fixed no dependa de nadie
    document.body.appendChild(velo);
    document.body.appendChild(hoja);

    velo.addEventListener('click', cerrarHoja);
    hoja.querySelectorAll('[data-asura-cerrar]').forEach(function (b) {
      b.addEventListener('click', cerrarHoja);
    });
    hoja.querySelectorAll('[data-asura-ver-carrito]').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(abrirCarrito, dur(320)); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && abierta()) cerrarHoja();
    });

    var pagar = hoja.querySelector('.asura-hoja__pagar');
    if (pagar) {
      pagar.form.addEventListener('submit', function () { pagar.classList.add('btn--loading'); });
      window.addEventListener('pageshow', function () { pagar.classList.remove('btn--loading'); });
    }

    // deslizar hacia abajo para cerrar
    var agarre = hoja.querySelector('[data-asura-agarre]');
    var y0 = null;
    var dy = 0;
    if (agarre) {
      agarre.addEventListener('pointerdown', function (e) {
        if (e.target.closest('[data-asura-cerrar]') || window.innerWidth > 768) return;
        y0 = e.clientY;
        dy = 0;
        hoja.style.transition = 'none';
        try { agarre.setPointerCapture(e.pointerId); } catch (err) {}
      });
      agarre.addEventListener('pointermove', function (e) {
        if (y0 === null) return;
        dy = Math.max(0, e.clientY - y0);
        hoja.style.transform = 'translateY(' + dy + 'px)';
        velo.style.opacity = String(Math.max(0, 1 - dy / 320));
      });
      var soltar = function () {
        if (y0 === null) return;
        y0 = null;
        hoja.style.transition = '';
        if (dy > 70) {
          cerrarHoja();
        } else {
          hoja.style.transform = '';
          velo.style.opacity = '';
        }
      };
      agarre.addEventListener('pointerup', soltar);
      agarre.addEventListener('pointercancel', soltar);
    }
  }

  /* ------------------------------------------------------------------------
     Eventos del tema
     ------------------------------------------------------------------------ */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('.product-single__form')) return;
    var boton = form.querySelector('[data-add-to-cart]');
    if (!boton || boton.disabled) return;
    ultimoBoton = boton;
    iniciar(boton);
  }, true);

  document.addEventListener('ajaxProduct:added', function (e) {
    // el tema también lo dispara sin detalle cuando la tienda rechazó el
    // perfume (p. ej. ya no hay más piezas): el oro se vacía
    if (!e.detail || !e.detail.product) {
      var previo = ultimoBoton && ultimoBoton._asura;
      if (previo && previo.estado === 'llenando') vaciar(previo, true);
      return;
    }
    var p = e.detail.product;
    var boton = e.detail.addToCartBtn || ultimoBoton;
    if (boton) ultimoBoton = boton;
    var s = boton && boton._asura;
    var habia = habiaAntes !== null ? habiaAntes : document.body.classList.contains('cart-has-items');
    habiaAntes = null;

    var conteo = contarCarrito();
    var oro = completar(s);

    Promise.all([oro, conteo]).then(function (r) {
      carritoNuevo = !habia && r[1] > 0;
      setTimeout(function () { abrirHoja(p); }, r[0] ? dur(420) : 0);
    });
  });

  document.addEventListener('ajaxProduct:error', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form') : null;
    var boton = form ? form.querySelector('[data-add-to-cart]') : ultimoBoton;
    if (boton && boton._asura && boton._asura.estado !== 'listo') vaciar(boton._asura, true);
  });
})();
